import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PartGroup } from '../../../opc-app/partgroup/partgroup.model';
import { SelectItem } from 'primeng/api';
import { PartCategory } from '../../../opc-app/partcategory/partcategory.model';
import { ProductLine } from '../../../opc-app/productline/productline.model';

@Component({
  selector: 'app-part-filter',
  templateUrl: './part-filter.component.html',
  styleUrls: ['./part-filter.component.css']
})
export class PartFilterComponent {
  alphaNumeric: string[] = '#,0 - 9,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z'.split(',');
  loading = false;
  partGroups: PartGroup[];
  productLineOptions: SelectItem[] = [];
  partCategories: PartCategory[];
  productLines: ProductLine[];

  @Input() selectedCharacter: string | null = null;
  @Output() characterSelected = new EventEmitter<string>();

  selectCharacter(char: string) {
    this.characterSelected.emit(char);
  }
}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/partgroup/part-filter/part-filter.component.ts